const resources = {
    gotIt: 'Got It'
};

module.exports = function getResource(label, vars = []) {
    return resources[label];
};
